import { colors } from './colors';

export const statusColor = {//Background
    null: colors.grey,
    1: colors.shades200,
    2: colors.warning100,
    3: colors.secondary100,
    4: colors.success100,
    5: colors.warning100,
    6: colors.errorCode100,
    7: colors.shades100,
    8: colors.shades50,
    11: colors.success100,
    12: colors.errorCode100,
    13: colors.warning100,
    14: colors.blue,
    15: colors.grey,
    19: colors.success100,
    20: colors.blue,
    21: colors.grey,
    22: colors.green,
    23: colors.red,
    24: colors.green,
    25: colors.red,
    26: colors.green,
    27: colors.red,
    28: colors.grey,
    29: colors.blue,
    30: colors.yellow,
    31: colors.errorCode100,
    32: colors.secondary100,
    36: colors.red,
    50: colors.secondary100,
    51: colors.success100,
    52: colors.errorCode100,
    53: colors.shades100,

    60: colors.warning100,
    61: colors.secondary100,
    62: colors.success100,
    63: colors.errorCode100,

    90: colors.shades300,
    91: colors.secondary100,
    92: colors.success100,
    93: colors.warning100,
    94: colors.secondary100,
    95: colors.errorCode100,
    96: colors.errorCode100,

    111: colors.shades200,
    112: colors.warning100,
    113: colors.success100,
    114: colors.errorCode100,
    115: colors.errorCode100,

    130: colors.success100,
    131: colors.warning100,
    132: colors.errorCode100,
    133: colors.shades200,
    135: colors.secondary100,

    153: colors.secondary100,
    154: colors.success100,
    155: colors.errorCode100,
    156: colors.shades100,
    157: colors.secondary100,

    500:colors.errorCode100,
    1000:colors.shades100,
    department_no_authorized_to_approve: colors.orange,
    contract_inactive_employee: colors.grey
};//End background

export const statusFontColor = {//Font
    null: colors.grey,
    1: colors.shades700,
    2: colors.warning700,
    3: colors.secondary700,
    4: colors.success700,
    5: colors.warning700,
    6: colors.errorCode700,
    7: colors.shades500,
    8: colors.shades500,
    11: colors.success700,
    12: colors.errorCode700,
    13: colors.warning700,
    19: colors.success700,
    31: colors.errorCode700,
    32: colors.secondary700,
    50: colors.secondary700,
    51: colors.success700,
    52: colors.errorCode700,
    53: colors.shades500,

    60: colors.warning700,
    61: colors.secondary700,
    62: colors.success700,
    63: colors.errorCode700,

    90: colors.shades700,
    91: colors.secondary700,
    92: colors.success700,
    93: colors.warning700,
    94: colors.secondary700,
    95: colors.errorCode700,
    96: colors.errorCode700,

    111: colors.shades700,
    112: colors.warning700,
    113: colors.success700,
    114: colors.errorCode700,
    115: colors.errorCode700,

    130: colors.success700,
    131: colors.warning700,
    132: colors.errorCode700,
    133: colors.shades700,
    135: colors.secondary700,

    153: colors.secondary700,
    154: colors.success700,
    155: colors.errorCode700,
    156: colors.shades700,
    157: colors.secondary700,

    1000:colors.shades700
};// End font

export const statusBorderColor = {//Border

    null: colors.grey,
    1: colors.shades150,
    2: colors.warning150,
    3: colors.secondary150,
    4: colors.success150,
    5: colors.warning150,
    6: colors.errorCode150,
    7: colors.shades150,
    8: colors.shades100,
    11: colors.success150,
    12: colors.errorCode150,
    13: colors.warning150,
    19: colors.success150,
    31: colors.errorCode150,
    32: colors.secondary150,
    50: colors.secondary150,
    51:  colors.success150,
    52: colors.errorCode150,
    53: colors.shades150,

    60: colors.warning150,
    61: colors.secondary150,
    62: colors.success150,
    63: colors.errorCode150,

    90: colors.shades150,
    91: colors.secondary150,
    92: colors.success150,
    93: colors.warning150,
    94: colors.secondary150,
    95: colors.errorCode150,
    96: colors.errorCode150,

    111: colors.shades150,
    112: colors.warning150,
    113: colors.success150,
    114: colors.errorCode150,
    115: colors.errorCode150,

    130: colors.success150,
    131: colors.warning150,
    132: colors.errorCode150,
    133: colors.shades150,
    135 :colors.secondary150,

    153: colors.secondary150,
    154: colors.success150,
    155: colors.errorCode150,
    156: colors.shades150,
    157: colors.secondary150,

    1000:colors.shades300
};// End border


export const chipStatusClassColor = {//Class color
    null: "",
    1: null,
    2: "",
    3: "chip-secondary-150-100",
    4: "chip-success-150-100",
    5: "chip-warning-150-100",
    6: "chip-error-code-150-100",
    11: "",
    12: "",
    13: "",
    14: "",
    15: "",
    19: "",
    20: "",
    21: "",
    22: "",
    23: "",
    24: "",
    25: "",
    26: "",
    27: "",
    28: "",
    29: "",
    30: "",
    31: "",
    32: "chip-secondary-150-100",
    33: "",
    34: "",
    36: "",
    50: "",
    51: "",
    62: "",
    63: "",
    60: "",
    61: "",

    90: "",
    91: "",
    92: "chip-success-150-100",
    93: "",
    94: "",
    95: "chip-error-code-150-100",
    96: "chip-error-code-150-100",

    110: "chip-shades-150-200",
    111: "chip-shades-150-200",
    112: "chip-warning-150-100",
    113: "chip-success-150-100",

    130: "chip-success-150-100",
    131: "chip-warning-150-100",
    132: "chip-error-code-150-100",
    133: "chip-shades-150-200",
    135: "chip-success-150-100",

    153: "chip-secondary-150-100",
    154: "chip-success-150-100",
    155: "chip-error-code-150-100",
    156: "chip-shades-150-200",
    157: "chip-secondary-150-100",

    500:"",
};//End Status Class Color

export const chipStatusIconClassColor = {//Class color
    null: "",
    1: null,
    2: "",
    3: "icon-color-secondary-700",
    4: "icon-color-primary-700",
    5: "icon-color-warning-700",
    6: "icon-color-error-code-700",
    11: "",
    12: "",
    13: "",
    14: "",
    15: "",
    19: "",
    20: "",
    21: "",
    22: "",
    23: "",
    24: "",
    25: "",
    26: "",
    27: "",
    28: "",
    29: "",
    30: "",
    36: "",
    50: "",
    31: "",
    32: "",
    33: "",
    34: "",
    51: "",
    62: "",
    63: "",
    60: "",
    61: "",

    90: "",
    91: "icon-color-shades-700",
    92: "icon-color-success-700",
    93: "",
    94: "",
    95: "icon-color-error-code-700",
    96: "icon-color-error-code-700",

    110: "icon-color-shades-700",
    111: "icon-color-shades-700",
    112: "icon-color-warning-700",
    113: "icon-color-success-700",

    130: "icon-color-success-700",
    131: "icon-color-warning-700",
    132: "icon-color-error-code-700",
    133: "icon-color-shades-700",
    135: "icon-color-success-700",
    155: "icon-color-error-code-700",
    157: "icon-color-secondary-700",
    500:"",
};//End Status Class Color

